import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useExternalInputContext } from './ExternalInputContext';

const RouteWatcher: React.FC = () => {
  const location = useLocation();
  const {
    setExternalKeywordsList,
    setExternalFilterId,
    setExternalLockedProducerLiterals,
    setExternalSearchPartial,
    setExternalSearchPartialProducer,
    setExternalFetchedWines,
    setExternalFetchedProducers,
    setExternalSelectedWineRows,
    setExternalMergeModalWines,
    setExternalWinesPage,
    setExternalProducersPage,
    setExternalHasMoreWines,
    setExternalHasMoreProducers,
    setExternalTotalRowsOfWines,
    setExternalTotalRowsOfProducers,
    setExternalShowMergeModal,
    setExternalShowProducerModal,
    setExternalSelectedProducerId,
    setExternalNumberOfFiles,
    setExternalUniqueKey,
    setExternalFileName,
    setExternalTableData,
    setExternalCurrentIndex,
    setExternalDataLoaded,
    setExternalMatchedWine,
  } = useExternalInputContext();

  // Define allowed routes where external context data should persist
  const allowedRoutes = [
    '/wine-addition/external',
    '/wine-addition/new-producer', 
    '/wine-addition/add-wine',
    '/wine-addition/edit-wine'
  ];

  useEffect(() => {
    const currentPath = location.pathname;
    const shouldKeepData = allowedRoutes.some(route => currentPath.startsWith(route));
    
    if (!shouldKeepData) {
      // Reset all state values to their initial state
      setExternalKeywordsList([]);
      setExternalFilterId('');
      setExternalLockedProducerLiterals([]);
      setExternalSearchPartial(true);
      setExternalSearchPartialProducer(true);
      setExternalFetchedWines([]);
      setExternalFetchedProducers([]);
      setExternalSelectedWineRows([]);
      setExternalMergeModalWines([]);
      setExternalWinesPage(1);
      setExternalProducersPage(1);
      setExternalHasMoreWines(true);
      setExternalHasMoreProducers(true);
      setExternalTotalRowsOfWines(0);
      setExternalTotalRowsOfProducers(0);
      setExternalShowMergeModal(false);
      setExternalShowProducerModal(false);
      setExternalSelectedProducerId(null);
      setExternalNumberOfFiles(0);
      setExternalUniqueKey('');
      setExternalFileName('');
      setExternalTableData([]);
      setExternalCurrentIndex(0);
      setExternalDataLoaded(false);
      setExternalMatchedWine(null);
    }
  }, [location.pathname, setExternalKeywordsList, setExternalFilterId, setExternalLockedProducerLiterals, setExternalSearchPartial, setExternalSearchPartialProducer, setExternalFetchedWines, setExternalFetchedProducers, setExternalSelectedWineRows, setExternalMergeModalWines, setExternalWinesPage, setExternalProducersPage, setExternalHasMoreWines, setExternalHasMoreProducers, setExternalTotalRowsOfWines, setExternalTotalRowsOfProducers, setExternalShowMergeModal, setExternalShowProducerModal, setExternalSelectedProducerId, setExternalNumberOfFiles, setExternalUniqueKey, setExternalFileName, setExternalTableData, setExternalCurrentIndex, setExternalDataLoaded, setExternalMatchedWine]);

  return null; // This component doesn't render anything
};

export default RouteWatcher;
